import Pusher from 'pusher-js';
import { PUSHER_CLUSTER, PUSHER_KEY } from './global-variables';

export const CART_UPDATED = 'CART_UPDATED';

export default new Pusher(PUSHER_KEY, {
  cluster: PUSHER_CLUSTER,
  encrypted: true,
});
